// extracted by mini-css-extract-plugin
module.exports = {"NewsWrapper_wrapper":"NewsWrapper_NewsWrapper_wrapper__QPEZo","header_Wrapper":"NewsWrapper_header_Wrapper__1JpuQ","newscard_wrapper":"NewsWrapper_newscard_wrapper__3I9RS"};